<template>
  <div>
    <h2><router-link :to="{ name: 'pos' }">รายการขาย POS</router-link> > <router-link :to="{ name: 'pos_device' }">เลือกสาขา POS</router-link> > เลือกสาขา POS</h2>
    <POSCreator
      :deviceId="$route.params.device_id"
    ></POSCreator>
  </div>
</template>
<script>
import POSCreator from './components/POSCreator.vue'
export default {
  data() {
    return {}
  },
  components: {
    POSCreator,
  },
}
</script>
